import styled from 'styled-components'
import { Box } from '@pinchenterprisesnpm/friday-ui'

export const ScreeningRequirementsStepContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
`
